<template>
  <!-- D: 로딩화면은 modal처럼 .l-wrap 바깥에 넣어주세요. -->
  <div
    v-if="data.visible"
    class="loading"
    ref="loadingRef"
    tabIndex="-1"
    data-alert
  >
    <div class="loading-inner">
      <div class="loading-img">
        <img src="@/assets/images/etc/loading.svg" alt="" />
      </div>
      <div class="loading-text">
        <p v-if="data.message" class="text">{{ data.message }}<br /></p>
      </div>
      <p class="text" style="display: none">
        <button @click="confirmAction">닫기</button>
      </p>
    </div>

    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>

<script setup name="LoadingDialog">
import { reactive, onMounted, defineProps, watch, ref, nextTick } from "vue";
import { useLoading } from "@/components/paintpro/composables/useLoading";
const { confirmAction } = useLoading();

const loadingRef = ref(null);

const props = defineProps({
  uid: {
    // props로 고유 ID 받기
    type: String,
    required: false,
  },
});

const data = reactive({
  id: "",
  message: "",
  type: "",
  visible: false,
  options: {},
});

watch(
  () => data.visible,
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        handleOpen();
      });
    } else {
      enablePageScroll(); // 팝업 닫을 때 스크롤 복원
    }
  }
);
onMounted(() => {
  const { visible, message, type, options } = useLoading(props.uid);
  data.id = props.uid;
  data.message = message;
  data.visible = visible;
  data.type = type;
  data.options = options;
  enablePageScroll(); // 초기 상태에서는 스크롤 활성화
});

function handleOpen() {
  loadingRef.value.focus();
  setupFocusTrap(loadingRef.value);
  disablePageScroll(); // 스크롤 방지
}

function setupFocusTrap(el) {
  // 팝업 내부의 포커스 가능한 요소들
  const focusableElements = el.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  if (focusableElements.length > 0) {
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    el.addEventListener("keydown", function (e) {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  } else {
    el.focus();
  }
}

// 페이지 스크롤 비활성화
const disablePageScroll = () => {
  document.body.style.overflow = "hidden"; // 스크롤 비활성화
};

// 페이지 스크롤 활성화
const enablePageScroll = () => {
  document.body.style.overflow = ""; // 스크롤 원상복구
};
</script>
